<!-- Default preloader -->
@if (isOverlay) {
  <div class="overlay">
    <div class="preloader-container">
      <mat-progress-spinner [diameter]="size || 40"
        class="primary"
        mode="indeterminate">
      </mat-progress-spinner>
      @if (!hideLabel) {
        <span class="small">{{label}}</span>
      }
    </div>
  </div>
}

<!-- Preloader for section -->
@if (isSection) {
  <section>
    <div class="overlay">
      <div class="preloader-container">
        <mat-progress-spinner [diameter]="size || 40"
          class="primary"
          mode="indeterminate">
        </mat-progress-spinner>
        @if (!hideLabel) {
          <span class="small">{{label}}</span>
        }
      </div>
    </div>
  </section>
}

<!-- Icon preloader -->
@if (isIcon) {
  <mat-progress-spinner [diameter]="size || 30" mode="indeterminate"></mat-progress-spinner>
}
